/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */

import { enableStickyPosition } from './helpers';
import withFixedColumnsScrollEvent from './scrollEvent';
import withFixedColumnsStickyPosition from './stickyPosition';

const WithFixedColumns = enableStickyPosition()
    ? withFixedColumnsStickyPosition
    : withFixedColumnsScrollEvent; // use for legacy browser

export {
    withFixedColumnsStickyPosition,
    withFixedColumnsScrollEvent,
};

export default WithFixedColumns;
